<template>
  <div>
    <div
      v-if="isVisible"
      class="jProgressScreen">
      <div
        id="progress-screen"
        class="notification-screen">
        <div class="floating-container">
          <span>
            <i class="fa fa-check-circle"/>
          </span>
          <h1 id="progress-screen-data">Processing {{ retrievedData.length }}/{{ max }}</h1>
          <b-progress
            :max="max"
            class="mb-3">
            <b-progress-bar
              :value="numOfFailed"
              variant="danger"/>
            <b-progress-bar
              :value="numOfSuccess"
              variant="success"/>
          </b-progress>
          <div id="progress-screen-message">
            <span class="span__success--green">{{ numOfSuccess }} data success</span>
            <br>
            <span class="span_failed--red">{{ numOfFailed }} data failed</span>
            <div
              v-if="getErrorDatas.length > 0"
              id="progress-message-container">
              <p>Problem Message:</p>
              <div id="box">
                <p
                  v-for="(errorData, index) in getErrorDatas"
                  :key="index">
                  - Data {{ errorData.index }}: {{ errorData.message }}.
                </p>
              </div>
            </div>
          </div>
          <br>
          <b-button
            v-if="finish"
            id="progress-screen-finish"
            variant="success"
            @click="toggleIsVisible">
            Finish
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from 'axios';
import jApi from '@/services/jApi';

export default {
  name: 'JProgressScreen',
  props: {
    dataKirim: {
      type: Array,
      default: () => ([]),
    },
    urlApi: {
      type: String,
      default: '',
    },
    headers: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      numOfFailed: 0,
      numOfSuccess: 0,
      max: 0,
      retrievedData: [],
      isVisible: false,
      finish: false,
    };
  },
  computed: {
    getErrorDatas() {
      return this.retrievedData.filter((data, index) => {
        if (data.error === true) {
          const datas = data;
          datas.index = index + 1;
          datas.message = data.message;
          return datas;
        }
        return '';
      });
    },
  },
  watch: {
    retrievedData() {
      this.numOfFailed = this.getErrorDatas.length;
      this.numOfSuccess = this.retrievedData.length - this.numOfFailed;
    },
  },
  methods: {
    toggleIsVisible() {
      this.isVisible = !this.isVisible;
      if (this.isVisible === true) {
        this.process();
      } else {
        this.retrievedData = [];
        this.max = 0;
        this.$emit('finish');
      }
    },
    process() {
      this.finish = false;
      const shootTimes = this.dataKirim.length;
      this.max = shootTimes;

      const api = jApi.generateApi();

      const retrieveDataPromises = [];

      for (let i = 0; i < shootTimes; i += 1) {
        retrieveDataPromises.push(
          new Promise(((resolve, reject) => {
            api.post(this.urlApi, this.dataKirim[i])
              .then((response) => {
                const responses = response;
                this.retrievedData.push(responses.data);
                resolve();
              })
              .catch((error) => {
                // handle error
                this.retrievedData.push(error.response.data);
                reject();
              });
          })),
        );
      }

      Promise.all(retrieveDataPromises).then(() => {
        this.finish = true;
      }).catch(() => {
        this.finish = true;
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/progress-screen/jProgressScreen.vue